import { List as IList } from 'immutable';

// eslint-disable-next-line import/prefer-default-export
export const selectCompaniesList = (state) => state.companiesReducer.get('companies', IList());
export const selectLoaderVisible = (state) => state.feedContentReducer.get('loaderVisible', false);
